export let delivering_detail = {
	background_image_height:"54vw",
	background_image: "/images/header_images/civil_engineer_backgroung.png",
	title: " DELIVERING <span style='color:#FCA87E;'> DETAILED AND ACCURATE </span>CONSTRUCTION COST ESTIMATES & MATERIAL TAKEOFFS.",
	description: "If you’re a building professional or a contractor, you’ve come to the right place! Automating your estimating process is going to make your job a lot easier. Automason provides conceptual estimates, hard bid estimates, and material takeoffs in a few easy steps."	
}
export let delivering_detail_mob = {
	background_image_height: "215.421vw",
        background_image:
            "/images/header_images/civil_engineers_background_mob.png",
        title: "Delivering <br><span style='color:#FCA87E;'> detailed and accurate </span>construction cost estimates & material takeoffs.",
        description:
            "If you’re a building professional or a contractor, you’ve come to the right place!",
        description2:
            "Automating your estimating process is going to make your job a lot easier. Automason provides conceptual estimates, hard bid estimates, and material takeoffs in a few easy steps.",
    };
export let faqs = {
	background_image_height:"29.063vw",
	background_image: "/images/header_images/faq_background.png",
	title: "<span style='color:#FCA87E;'> FAQs </span>",
	description: ""
}
export let faqs_mob = {
	background_image_height:"149.533vw",
	background_image: "/images/header_images/faq_background_mob.png",
	title: "<span style='color:white;font-size:11.215vw;font-weight:600;'> FAQs </span>",
	description: "",
	description2:" ",
}

export let drafting_service = {
	background_image_height:"44.531vw",
	background_image: "/images/header_images/drafting_service_background.png",
	title: " <span style='color:#FCA87E;'>Drafting </span> Services",
	description: "<span style='font-weight:400; font-size:1.563vw;' >You will need a clear drafting plan to prevent confusion and save time and money during the construction process. </span>"
}

export let drafting_service_mob = {
	background_image_height:"215.421vw",
	background_image: "/images/header_images/drafting_service_background_mob.png",
	title: "<span style='font-size:14.019vw;line-height:13.458vw;'> <span style='color:#FCA87E;'>Drafting </span> <span style='color:black;'>Services</span></span>",
	description: " ",
	description2:"<span style='color:black;'>You will need a clear drafting plan to prevent confusion and save time and money during the construction process.</span>",
} 

export let design_analysis = {
	background_image_height:"44.531vw",
	background_image: "/images/design_analysis/design_analysis_background.png",
	title: " <span style='color:#FCA87E;'>Design & Analysis </span> Services",
	description: "<span style='font-weight:400; font-size:1.563vw;' >We have a team of experts who specialize in design and provide effective solutions for structural analysis and performance according to time and budget constraints."
}
export let design_analysis_mob = {
	background_image_height:"215.421vw",
	background_image: "/images/design_analysis/mobile/main_image.png",
	title: " <span style='font-size:11.215vw; line-height:13.458vw;'><span style='color:#FCA87E;'>Design & Analysis </span> Services</span>",
	description: "<span style='font-style:normal;font-weight:400; '>We have a team of experts who specialize in design and provide effective solutions for structural analysis and performance according to time and budget constraints.</span> ",
	description2: " ",
}
export let pricing = {
	background_image_height:"29.063vw",
	background_image: "/images/header_images/pricing_background.png",
	title: "<span style='color:#FCA87E;'> Pricing </span>",
	description: "",
}
export let pricing_mob = {
	background_image_height:"149.533vw",
	background_image: "/images/header_images/pricing_background_mob.png",
	title: "<span style='color:#FCA87E; font-size:14.019vw; font-weight:600;'> Pricing </span>",
	description: "",
	description2: " ",
}
export let estimate_service = {
	background_image_height:"44.531vw",
	background_image: "/images/header_images/estimate_service_back.png",
	title: " <span style='color:#FCA87E;'>Estimation </span> Services",
	description: "<span style='font-size:1.563vw; font-weight:400;'> If you want to accurately calculate costs without losing  <br> money in contracts, we’ve got you covered.</span> "
}
export let estimate_service_mob = {
	background_image_height:"215.421vw",
	background_image: "/images/header_images/estimate_service_back_mob.png",
	title: " <span style='font-size:11.215vw; line-height:13.458vw;'><span style='color:#FCA87E; '>Estimation </span> Services</span>",
	description: "<span style='font-weight:400;font-style:normal;font-size: 2.804vw; font-family: 'Poppins';'>If you want to accurately calculate costs without losing money in contracts, we’ve got you covered.</span> ",
	description2:" ",
}